import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {EnvironmentService} from '../EnvironmentService';
import {BrandingConfig} from '../branding/BrandingConfig';
import {BrandingTypes} from '../branding/BrandingType.js';

@Injectable({
    providedIn: 'root'
})
export class OrganizationBrandingResource {
    constructor(private http: HttpClient, private environmentService: EnvironmentService) {
    }

    public loadLearnerBranding(organizationId?: string): Observable<BrandingConfig> {
        const organizationIdParam = organizationId !== undefined && organizationId !== '' ? `?organizationId=${organizationId}` : '';
        return this.http.get<BrandingConfig>(`${this.environmentService.environment.serverUrl}/api/learn/branding/organization${organizationIdParam}`);
    }

    public loadLearnerProfileBranding(organizationId?: string): Observable<BrandingConfig> {
        const organizationIdParam = organizationId !== undefined && organizationId !== '' ? `?organizationId=${organizationId}` : '';
        return this.http.get<BrandingConfig>(`${this.environmentService.environment.serverUrl}/api/profile/branding/organization${organizationIdParam}`);
    }

    public loadTaskbaseBranding(): Observable<BrandingConfig> {
        return this.http.get<BrandingConfig>(`${this.environmentService.environment.serverUrl}/api/profile/branding/type`, {params: {type: BrandingTypes.TASKBASE}});
    }

    public loadMicromateBranding(): Observable<BrandingConfig> {
        return this.http.get<BrandingConfig>(`${this.environmentService.environment.serverUrl}/api/profile/branding/type`, {params: {type: BrandingTypes.MICROMATE}});
    }

}

